import { Component, OnInit, inject } from '@angular/core';
import { TelemetryService } from '../../../services/telemetry/telemetry.service';
import { Telemetrigram } from '../../../models/data/operations/telemetrigram';

@Component({
    selector: 'app-telemetor',
    templateUrl: './telemetor.component.html',
    styleUrls: ['./telemetor.component.css']
})

export class TelemetorComponent implements OnInit {

    protected telemetryService = inject(TelemetryService);

    public constructor() { } // public telemetryService: TelemetryService) { }

    public ngOnInit(): void { }

    public emitTelemetrigram = (operationName: string): void => {

        const windowLocation: Location | null = typeof window !== 'undefined' ? window.location : null;
        const hostnameParts: string[] = windowLocation?.hostname.split('.') ?? [];
        const tld: string | undefined = hostnameParts.length > 0 ? hostnameParts.pop() ?? undefined : undefined;
        const domain: string | undefined = hostnameParts.length > 0 ? hostnameParts.pop() ?? undefined : undefined;
        const subdomain: string | undefined = hostnameParts.length > 0 ? hostnameParts.join('.') || undefined : undefined;
        const componentName: string | undefined = this.constructor.name;
        const referrer: string | undefined = typeof document !== 'undefined' ? document.referrer || undefined : undefined;
        const languageLocale: string | undefined = typeof navigator !== 'undefined' ? navigator.language ?? undefined : undefined;
        const screenResolution: string | undefined = typeof window !== 'undefined' && window.screen ? `${window.screen.width}x${window.screen.height}` : undefined;

        const telemetrigram: Telemetrigram = {
            TelemetrigramId: -1,
            URI: windowLocation == null ? "" : windowLocation.href,
            Scheme: windowLocation == null ? "" : windowLocation.protocol.replace(':', ''),
            Subdomain: subdomain,
            Domain: domain,
            TLD: tld,
            Path: windowLocation == null ? "" : windowLocation.pathname,
            QueryString: windowLocation == null ? "" : windowLocation.search.replace(/^\?/, ''),
            ComponentName: componentName,
            OperationName: operationName,
            IpAddress: "",                  // filled in by api
            Referrer: referrer,
            LanguageLocale: languageLocale,
            TraceIdentifier: "",            // filled in by api
            UserAgent: navigator.userAgent,
            ScreenResolution: screenResolution,
            CreatedOnUTC: new Date(),       // filled in by api
            CreateUserUID: ""               // filled in by api
        };

        this.telemetryService.createTelemetrigram(telemetrigram);
    }
}
